import React from 'react';
import styled from 'styled-components';

import { Button } from '@material-ui/core';

/* eslint-disable indent */
const Root = styled.div`
	button {
		padding: 10px 40px;
		background-color: ${(props) =>
			props.theme.palette.button.primary.backgroundColor};
		color: ${(props) => props.theme.palette.button.primary.color};
		box-shadow: none;
		font-size: 18px;
		text-transform: initial;
		border-radius: 50px;
		border: 2px solid ${(props) => props.theme.palette.button.primary.backgroundColor};

		&:hover {
			background-color: transparent;
			box-shadow: none;
			border: 2px solid ${(props) => props.theme.palette.button.primary.color};
		}
	}
`;

const BtnPrimary = (props) => (
	<Root>
		<Button {...props}>{props.children}</Button>
	</Root>
);

export default BtnPrimary;
